
import * as AWS from 'aws-sdk'

//AWS.config.update({region: 'eu-west-3'})

const docClient = new AWS.DynamoDB.DocumentClient()

export const fetchData = (tableName) => {
    if (!AWS.config.region) {
        AWS.config.update({
          region: 'eu-west-3'
        });
      }
    var params = {
        TableName: tableName
    }

    docClient.scan(params, function (err, data) {
        if (!err) {
            console.log(data)
        }
    })
}


export const putData = (tableName , data) => {
    if (!AWS.config.region) {
        AWS.config.update({
          region: 'eu-west-3'
        });
      }
    var params = {
        TableName: tableName,
        Item: data
    }
    
    docClient.put(params, function (err, data) {
        if (err) {
            console.log('Error', err)
        } else {
            console.log('Success', data)
        }
    })
}